import { CompanyConfigModel } from 'src/models/company-model';
import * as yup from 'yup';

export const companyConfigDefaultValues: CompanyConfigModel = {
  defaultUserGroup: '',
  shouldValidateCpf: false,
  sessionTimeoutInSeconds: 0,
  maxDownloadBandwidthInBps: 0
}

export const companyConfigSchemaValidation = yup.object({
  defaultUserGroup: yup.string().required(),
  shouldValidateCpf: yup.boolean().default(false).required(),
  sessionTimeoutInSeconds: yup.number().default(3600),
  maxDownloadBandwidthInBps: yup.object().nullable().required()
})
